import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/map';
import { Headers, RequestOptions, Response, Http } from '@angular/http';
import { AuthService } from '../shared/services/auth.service';

@Injectable()
export class RemnantsService {

  constructor(
    private _http:Http,
    private _authService:AuthService
  ) { }

  getInventory(filters) {
    const url = `${environment.apiUrl}inventory/remnants`;
    const token = this._authService.getToken();
    const headers = new Headers({
      'Content-Type': 'application/json',
      'Authorization': 'Bearer '+token
    });
    const options = new RequestOptions({ headers: headers });
    return this._http.post(url, {filter:filters}, options)
      .map( (resp: Response) => {
        return resp.json()
      })
      .catch( (error: any) =>  {
        return Observable.throw('Error')
      })
  }

}



// WEBPACK FOOTER //
// ./src/app/remnants/remnants.service.ts